import { render, staticRenderFns } from "./IconMakeDecisors.vue?vue&type=template&id=0fe1b556&"
import script from "./IconMakeDecisors.vue?vue&type=script&lang=ts&"
export * from "./IconMakeDecisors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports